@if (items()) {
  <div
    class="link-list-with-icons"
    [class.mr-xsmall-b]="!isNewBrand()"
    [class.ps-medium]="isNewBrand()"
    [class.elevation-level-1]="isNewBrand()"
    [class.rounded-large]="isNewBrand()"
  >
    <h2
      [ngClass]="{
        'mr-xsmall-b': !isNewBrand(),
        'ms-xsmall-b ms-clear-t font-title-small': isNewBrand(),
      }"
    >
      {{ content()?.teaserTitle }}
    </h2>
    <ul class="ms-clear">
      @for (item of items(); track item.contentId) {
        @if (item.target.url) {
          <li [class.ps-small-y]="isNewBrand()">
            <a
              class="nordic-blue-900-text text-icon-primary no-decoration flex font-label-medium"
              [finLink]="item.target.url"
              [external]="item.target.external"
              [attr.target]="item.target.external ? '_blank' : null"
              [attr.rel]="item.target.external ? 'noopener noreferrer' : null"
              data-testid="cms-link-list-link"
            >
              @if (item.localSettings?.iconName && isNewBrand()) {
                <fcom-icon [name]="item.localSettings.iconName" class="flex ms-small-r icon-medium" />
              }
              <span data-testid="cms-link-list-link-text">{{ item.teaserTitle }}</span>
              @if (!isNewBrand()) {
                <fcom-icon [name]="SvgLibraryIcon.ARROW_RIGHT" class="flex icon-medium" />
              }
            </a>
          </li>
        }
      }
    </ul>
  </div>
}
